import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';

import {AppHomeComponent} from './components/app-home/app-home.component';
import {AppUsersComponent} from './components/app-users/app-users.component';
import {UserDetailComponent} from './components/app-users/user-detail/user-detail.component';
import {AppLoginComponent} from './components/app-login/app-login.component';
import {AppTownshipsComponent} from './components/app-townships/app-townships.component';
import {TownshipDetailComponent} from './components/app-townships/township-detail/township-detail.component';

export const routes: Routes = [
  { path: 'login', component: AppLoginComponent, canActivate: [loginGuard] },
  { path: '', component: AppHomeComponent, canActivate: [authGuard], pathMatch: 'full' },
  { path: 'users', component: AppUsersComponent, canActivate: [authGuard] },
  { path: 'users/:id', component: UserDetailComponent, canActivate: [authGuard] },
  { path: 'townships', component: AppTownshipsComponent, canActivate: [authGuard] },
  { path: 'townships/:id', component: TownshipDetailComponent, canActivate: [authGuard] },

  { path: '**', redirectTo: '' },
];
